export enum RestCodes {
  Ok = 200,
  BadRequest = 400,
  NotFound = 404,
  Conflict = 409,
}

export enum TableFilterClub {
  PROFIT = "profit",
  NFT_TRANSACTIONS = "transactions",
  BALANCE = "balance",
  FUNDRAISE = "fundraise",
  VAULT = "vault",
  MEMBERS = "members",
  PROPOSALS = "proposals",
}

export enum TableFilterTradingTable {
  BUY = "Best buys of NFTs",
  SELL = "Best sells of NFTs",
}

export enum PeriodFilter {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum IProposalStatus {
  voting = "Voting",
  succedeed = "Succedeed",
  executing = "Executing",
  cancelled = "Cancelled",
  defeated = "Defeated",
  completed = "Completed",
}

export enum IProposalType {
  trading = "Trading",
  withdrawal = "Withdrawal",
  discussion = "Discussion",
}

export enum MemberRole {
  FOUNDER = 0,
  MANAGER = 1,
  MEMBER = 2,
}

export enum SequenceType {
  Sequential,
  Parallel,
  StopOnFailure,
}

export enum TransactionState {
  Pending,
  Loading,
  Succeeded,
  Failed,
}
